<template>
    <div class="dv_top_bar_geral">
        <div class="container2">
            <div class="dv_top_bar_main">
                <div class="dv_top_bar_p1">
                    <input class="in_search" type="text" placeholder="O que você está buscando?" v-model="searchText" v-on:keyup="getSearch()"/>
                    <img class="im_ic_lupa" :src="'/static/imgs/ics/ic_' + (showSearch ? 'close.png' : 'lupa.png')" @click="toogleShowSearch()"/>
                </div>
                <div class="dv_top_bar_p2">
                    <img class="im_top_bar_logo" src="/static/imgs/logo_dezoito.png" @click="goToHome()"/>
                </div>
                <div class="dv_top_bar_p3">
                    <div>
                        <img class="im_ic_cart" src="/static/imgs/ics/ic_cart.png"/>
                    </div>
                </div>
            </div>

            <!-- Categorias -->
            <div v-if="showCats" style="width: 100%; background-color: white; display: flex; justify-content: center">
                <div class="dv_top_bar_cats" :style="'margin-top: -' + top_bar_p2_margin_top + 'vh; '">
                    <div v-for="(item, i) in cats_full" :key="i" @click="changeCategoria(i + 1)">
                        <span v-if="categoriaIndexTop > 0 && categoriaIndexTop == i + 1" class="tx_top_cat_sel"> {{ item.nome.toUpperCase() }} </span>
                        <span v-else class="tx_top_cat"> {{ item.nome.toUpperCase() }} </span>
                    </div>
                </div>
                <div id="dv_search_m_id" class="dv_search_m" :style="'margin-top: -' + top_bar_search_margin_top + 'vh; '">
                    <input ref="search_i" class="in_search_m" type="text" placeholder="O que você está buscando?" v-model="searchText" v-on:keyup="getSearch()" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                    <img class="im_ic_cart" src="/static/imgs/ics/ic_lupa.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { commonMixin } from '../../scripts/commonMixin'

export default {
    mixins: [commonMixin],
    props: {
        showCats: {
            type: Boolean,
            default: false
        },
        categoriaIndexTop: {
            type: Number
        }
    },
    data () {
        return {
            top_bar_height_geral: 20,
            top_bar_p2_margin_top: 0,
            top_bar_search_margin_top: 4,

            showSearch: false,
            searchText: ''
        }
    },
    methods: {
        getSearch () {
            console.log('getSearch:antes ' + this.searchText)

            if (this.searchText.length < this.minSearchLen) {
                return
            }
            console.log('getSearch:depois ' + this.searchText)

            this.showSearch = true

            this.$emit('emit-search-text', this.searchText.toLowerCase())
        },
        closeKey () {
            console.log('closeKeyboard')
            this.$refs.search_i.blur()
        },
        goToHome () {
            this.$emit('emit-goToHome')
        },
        changeCategoria (index) {
            console.log('changeCategoria:TOPBAR: ', this.cats_full[index - 1].nome)
            console.log('changeCategoria:TOPBAR:INDEX: ', index)
            this.$emit('emit-categoria-index', index)
        },
        toogleShowSearch () {
            this.showSearch = !this.showSearch

            if (this.showSearch) {
                this.top_bar_search_margin_top = 0
            } else {
                this.searchText = ''
                this.top_bar_search_margin_top = 4
                this.goToHome()
            }
        },
        handleScroll (event) {
            // console.log('el.scrollHeight ', this.elScroll.scrollHeight, window.scrollY, this.elScroll.offsetTop)

            let p = window.scrollY / 1000.0
            if (p > 1) p = 1
            if (p < 0) p = 0

            if (this.isMobile()) {
                p = 1
            }

            // console.log('diff, p: ', p)
            this.top_bar_p2_margin_top = 4.1 * p
            // console.log('this.margin top 2', this.top_bar_p2_margin_top)
            // console.log('this.elPart0.scrollHeight: ', this.elPart0.scrollHeight)
            // console.log('window.scrollY: ', window.scrollY)
            // console.log('diff: ', diff)
            // console.log('percentual: ', p)
            // console.log('logoHeight: ', this.logoHeight)
            // console.log('logoMargin: ', this.logoMargin)
        }
    },
    mounted () {
        console.log('TopBar::mounted')

        if (this.isMobile()) {
            this.top_bar_p2_margin_top = 4.1
        } else {
            this.top_bar_p2_margin_top = 0
        }

        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    body {
        height: 100%;
    }

    .im_ic_cart, .im_ic_lupa {
        width: 4vh;
        height: 4vh;
        object-fit: scale-down;
    }

    .in_search, .in_search_m {
        /*border-bottom: red;*/
        border-top: none;
        border-left: none;
        border-right: none;
        border-color: black;
        width: 70%;
        font-size: 1.5vh;
    }

    .in_search_m {
        width: 80%;
        border-bottom: none;
    }

    .in_search:focus, .in_search_m:focus {
        outline: none;
    }

    .dv_top_bar_geral {
        position: fixed;
        top: 0;
        width: 100vw;
        background-color: white;
        /*height: 20vh;*/
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1;
        /*height: --var(height-top-bar-desk);*/
    }

    .dv_top_bar_main {
        display: flex;
        flex-direction: row;
        z-index: 10;
        height: var(--height-top-bar);
        width: 100%;
        background-color: white;
    }

    .dv_top_bar_p1, .dv_top_bar_p2, .dv_top_bar_p3 {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .dv_top_bar_p2 {
        width: 40%;
    }

    .dv_top_bar_p1, .dv_top_bar_p3 {
        width: 30%;
        /*background-color: purple;*/
    }

    .dv_top_bar_p1 {
        /*background-color: red;*/
        justify-content: flex-start;
    }

    .dv_top_bar_p3 {
        justify-content: flex-end;
    }

    .dv_top_bar_cats {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 4vh;
        width: 80%;
        font-size: 2vh;
        z-index: 9;
    }

    .dv_search, .dv_search_m {
        width: 100%;
        display: flex;
        flex-direction: row;
        background-color: white;
        justify-content: center;
    }
    .dv_search_m {
        display: none;
        /*display: flex;*/
        transition: all 0.3s linear;
        -webkit-transition: all 0.3s linear;
        -moz-transition: all 0.3s linear;
        -o-transition: all 0.3s linear;
        -ms-transition: all 0.3s linear;
    }

    .tx_top_cat, .tx_top_cat_sel {
        /*background-color: purple;*/
        /*font-family: 'Font1_Normal';*/
        /*font-family: 'Fonte2';*/
        font-size: 1.6vh;
        font-weight: bold;
        cursor: pointer;
    }
    .tx_top_cat:hover, .tx_top_cat_sel {
        border: solid;
        border-width: 2px;
        border-style: solid;
        border-color: darkgoldenrod;
        border-top: none;
        border-right: none;
        border-left: none;
    }

    .im_top_bar_logo {
        display: flex;
        height: 80%;
        object-fit: contain;
        cursor: pointer;
    }

    .container2 {
        /*background-color: yellow;*/
        width: 40%;
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        flex-direction: column;
        font-size: 2.5vh;
    }

    @media screen and (max-width: 999px) {
        .container2 {
            width: 100%;
        }
        .in_search {
            display: none;
        }
        /* barra de buscas inferior ao top bar */
        .dv_search_m {
            display: flex;
        }
        .im_ic_lupa {
            margin-left: 13vw;
            /*background-color: red;*/
        }
        .dv_top_bar_cats {
            display: none;
        }
    }
    @media screen and (min-width: 1000px) {
        .container2 {
            width: 90%;
        }
    }
    @media screen and (min-width: 1400px) {
        .container2 {
            width: 80%;
        }
    }
    @media screen and (min-width: 1600px) {
        .container2 {
            width: 70%;
        }
    }
    @media screen and (min-width: 1900px) {
        .container2 {
            width: 65%;
        }
    }
    @media screen and (min-width: 2200px) {
        .container2 {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/templates/Topbar.vue